module.exports = __webpack_public_path__ + "icon-twitter.74d4fa2a.svg";